import type { Bilingual } from './lang';

// ─────────────────────────────────────────────────────────────────────────────
// Shared glossary of common UI terms, so the same word is translated the same
// way everywhere. Import what you need and pass to `t(...)`:
//
//   import { G } from '../i18n/glossary';
//   const { t } = useLang();
//   <button>{t(G.save)}</button>
//
// RULE: trade/technical terms (Fire Alarm, BOM, RFI, submittal, device names,
// etc.) and currency/numbers stay ENGLISH in both languages — keep them out of
// here, or set en === fil. Documents are never translated.
// ─────────────────────────────────────────────────────────────────────────────

const b = (en: string, fil: string): Bilingual => ({ en, fil });

export const G = {
  // Actions
  save: b('Save', 'I-save'),
  saveChanges: b('Save changes', 'I-save ang mga pagbabago'),
  cancel: b('Cancel', 'Kanselahin'),
  close: b('Close', 'Isara'),
  add: b('Add', 'Magdagdag'),
  edit: b('Edit', 'I-edit'),
  delete: b('Delete', 'Burahin'),
  remove: b('Remove', 'Alisin'),
  confirm: b('Confirm', 'Kumpirmahin'),
  submit: b('Submit', 'Isumite'),
  back: b('Back', 'Bumalik'),
  next: b('Next', 'Susunod'),
  continue: b('Continue', 'Magpatuloy'),
  search: b('Search', 'Maghanap'),
  refresh: b('Refresh', 'I-refresh'),
  print: b('Print', 'I-print'),
  download: b('Download', 'I-download'),
  upload: b('Upload', 'Mag-upload'),
  open: b('Open', 'Buksan'),
  view: b('View', 'Tingnan'),
  reset: b('Reset', 'I-reset'),
  apply: b('Apply', 'Ilapat'),
  create: b('Create', 'Gumawa'),
  update: b('Update', 'I-update'),

  // Status / feedback
  loading: b('Loading…', 'Naglo-load…'),
  saving: b('Saving…', 'Sine-save…'),
  saved: b('Saved', 'Na-save'),
  noResults: b('No results', 'Walang resulta'),
  required: b('Required', 'Kailangan'),
  optional: b('Optional', 'Opsyonal'),
  yes: b('Yes', 'Oo'),
  no: b('No', 'Hindi'),
  error: b('Error', 'May error'),
  success: b('Success', 'Tagumpay'),

  // Auth / account
  signIn: b('Sign in', 'Mag-sign in'),
  signOut: b('Sign out', 'Mag-sign out'),
  changePassword: b('Change password', 'Palitan ang password'),
  password: b('Password', 'Password'),
  name: b('Name', 'Pangalan'),
  email: b('Email', 'Email'),
  role: b('Role', 'Tungkulin'),
  settings: b('Settings', 'Mga Setting'),

  // Common nouns / table headers
  date: b('Date', 'Petsa'),
  status: b('Status', 'Status'),
  actions: b('Actions', 'Mga Aksyon'),
  notes: b('Notes', 'Mga Tala'),
  description: b('Description', 'Paglalarawan'),
  quantity: b('Quantity', 'Dami'),
  total: b('Total', 'Kabuuan'),
  details: b('Details', 'Mga Detalye'),
} as const satisfies Record<string, Bilingual>;
